<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                {{ users.id ? 'Editar' : 'Novo' }} Usuário
              </div>
            </div>
            <div class="card-body">
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label><span class="required">*</span> Nome</label>
                  <input
                    v-model="users.name"
                    type="text"
                    class="form-control"
                    autocomplete="off"
                    placeholder=""
                  />
                </div>
                <div class="form-group col-md-6">
                  <label><span class="required">*</span> Login</label>
                  <input
                    v-model="users.login"
                    type="text"
                    class="form-control"
                    autocomplete="off"
                    placeholder=""
                  />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-md-6">
                  <label><span class="required">*</span> Nível de acesso</label>
                  <select
                    v-model="users.access_nivel"
                    class="form-control"
                  >
                    <option :value="3">Usuário Padrão</option>
                    <option :value="2">Gestor Empresa</option>
                    <option
                      v-if="$store.state.user.access_nivel == 1"
                      :value="1"
                    >
                      Administrador
                    </option>
                  </select>
                </div>
                <div class="form-group col-md-6">
                  <label>IPs de acesso</label>
                  <input
                    v-model="users.access_ip"
                    type="text"
                    class="form-control"
                    placeholder="Ex.: 127.0.0.1, 127.0.0.2"
                  />
                  <small class="text-muted">Separe múltiplos IPs por vírgula.</small>
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-md-6">
                  <label>CPF</label>
                  <input
                    v-model="users.cpf"
                    type="text"
                    class="form-control"
                    v-mask="'999.999.999-99'"
                  />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-md-12">
                  <label>Profissional vinculado</label>
                  <v-select
                    v-model="users.professional_id"
                    :options="professionals"
                    :reduce="(p) => p.id"
                    label="display_name"
                    class="vselect"
                    placeholder="Selecione o profissional (opcional)"
                  />
                  <small class="text-muted">
                    Necessário para aplicar restrição de CBO em prescrições.
                  </small>
                </div>
              </div>

              <!-- Senha: sempre visível em criação; toggle em edição -->
              <div
                v-if="users.id"
                class="mb-2"
              >
                <button
                  type="button"
                  class="btn btn-sm btn-outline-secondary"
                  @click="change_password = !change_password"
                >
                  <i class="fas fa-key mr-1" /> {{ change_password ? 'Ocultar senha' : 'Alterar senha' }}
                </button>
              </div>

              <div
                v-if="change_password"
                class="form-row"
              >
                <div class="form-group col-md-6">
                  <label><span class="required">*</span> Senha</label>
                  <input
                    v-model="users.password"
                    type="password"
                    class="form-control"
                    autocomplete="new-password"
                  />
                </div>
                <div class="form-group col-md-6">
                  <label><span class="required">*</span> Confirmar senha</label>
                  <input
                    v-model="users.password_confirmation"
                    type="password"
                    class="form-control"
                    autocomplete="new-password"
                  />
                </div>
              </div>

              <div class="form-group">
                <label>Foto do Perfil</label>
                <div class="user-img mb-1">
                  <img
                    v-if="previewImage"
                    :src="previewImage"
                    class="photo"
                  />
                </div>
                <input
                  id="userPic"
                  type="file"
                  accept="image/*"
                  @change="uploadImage"
                />
              </div>

              <hr />

              <span class="required_fields">
                <span class="required">*</span>
                <strong>Campos obrigatórios</strong>
              </span>
              <div class="block text-right mt-1">
                <router-link
                  to="/users"
                  class="btn btn-back mr-1"
                >
                  <i class="fa fa-arrow-left" /> Voltar
                </router-link>
                <button
                  v-if="$hasAbility('usuario.gerenciar')"
                  type="button"
                  class="btn btn-add"
                  :disabled="saving"
                  @click="save"
                >
                  <span
                    v-if="saving"
                    class="spinner-border spinner-border-sm mr-1"
                  />
                  <i
                    v-else
                    class="fa fa-save"
                  />
                  Salvar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
  name: 'UserAdd',
  components: { vSelect },
  data() {
    return {
      saving: false,
      professionals: [],
      change_password: true,
      users: {
        id: null,
        name: '',
        login: '',
        access_nivel: 3,
        access_ip: '',
        cpf: '',
        professional_id: null,
        password: '',
        password_confirmation: '',
        photo: '',
      },
      previewImage: null,
    }
  },
  mounted() {
    this.getProfessionals()

    const id = this.$route.params.id
    if (id) {
      this.change_password = false
      this.getUser(id)
    }
  },
  methods: {
    getProfessionals() {
      axios
        .get(this.$store.state.api + 'professionals?paginated=false&with=cbo')
        .then(res => {
          const list = res.data.data || res.data || []
          this.professionals = list.map(p => ({
            id: p.id,
            display_name: p.name + (p.cbo ? ' — ' + p.cbo.code : ''),
          }))
        })
        .catch(() => {})
    },
    getUser(id) {
      this.$loading(true)
      axios
        .get(this.$store.state.api + 'users/' + id)
        .then(res => {
          const user = Array.isArray(res.data.data) ? res.data.data[0] : res.data.data
          if (user) {
            this.users = {
              ...this.users,
              ...user,
              password: '',
              password_confirmation: '',
            }
          }
        })
        .catch(err => {
          const msg = err && err.response && err.response.data
            ? err.response.data
            : 'Erro ao carregar usuário.'
          this.$message('Erro', msg, 'error')
        })
        .finally(() => {
          this.$loading(false)
        })
    },
    uploadImage(e) {
      const file = e.target.files[0]
      if (!file) return
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = ev => { this.previewImage = ev.target.result }
    },
    save() {
      this.saving = true
      const api = this.$store.state.api + 'users' + (this.users.id ? '/' + this.users.id : '')

      const fd = new FormData()
      fd.append('name', this.users.name || '')
      fd.append('login', this.users.login || '')
      fd.append('access_nivel', this.users.access_nivel || '')
      fd.append('access_ip', this.users.access_ip || '')
      fd.append('cpf', this.users.cpf || '')
      fd.append('professional_id', this.users.professional_id || '')
      fd.append('rg', this.users.rg || '')
      fd.append('cellphone', this.users.cellphone || '')
      fd.append('status', this.users.status || '')
      fd.append('login_attempts', 0)

      if (this.change_password) {
        fd.append('password', this.users.password || '')
        fd.append('password_confirmation', this.users.password_confirmation || '')
      }

      const photo = document.getElementById('userPic')
      if (photo && photo.files[0]) {
        fd.append('photo', photo.files[0])
      }

      fd.append('_method', this.users.id ? 'PUT' : 'POST')
      if (this.users.id) fd.append('id', this.users.id)

      axios
        .post(api, fd)
        .then(() => {
          this.$message('Sucesso', 'Informações salvas com sucesso.', 'success')
          this.$router.push('/users')
        })
        .catch(err => {
          const msg = err && err.response && err.response.data
            ? err.response.data
            : 'Erro ao salvar usuário.'
          this.$message('Erro', msg, 'error')
        })
        .finally(() => {
          this.saving = false
        })
    },
  },
}
</script>

<style scoped>
.photo {
  display: block;
  width: 100px;
  height: 100px;
  border-radius: 8px;
  object-fit: cover;
}
</style>
